var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-container"},[_c('el-tag',{staticStyle:{"margin-bottom":"20px"}},[_c('a',{attrs:{"href":"https://github.com/PanJiaChen/vue-element-admin/tree/master/src/components/TreeTable","target":"_blank"}},[_vm._v("Documentation")])]),_c('tree-table',{attrs:{"data":_vm.data,"columns":_vm.columns,"border":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }